import React, { useEffect, useMemo } from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useGetFieldsByProjectAndIssueType } from '../JiraConnect.hooks';

export interface JiraIssueFieldPickerProps {
  issueTypeId: string;
  projectId: string;
  value?: string;
  disabled?: boolean;
  textFieldProps?: Omit<TextFieldProps, 'variant'>;
  onChange?: (issueField: string) => void;
}

const JiraIssueFieldPicker: React.FC<JiraIssueFieldPickerProps> = ({
  issueTypeId,
  projectId,
  value,
  disabled,
  textFieldProps,
  onChange
}) => {
  const [{ data: issueFields, isLoading, error }, getIssueFields] =
    useGetFieldsByProjectAndIssueType(projectId, issueTypeId);

  const options = useMemo(() => {
    return Object.keys(
      issueFields?.projects[0].issuetypes[0]?.fields || []
    ).map(keyName => ({
      key: issueFields?.projects[0].issuetypes[0]?.fields[keyName].key,
      name: issueFields?.projects[0].issuetypes[0]?.fields[keyName].name
    }));
  }, [issueFields]);

  const selected = useMemo(() => {
    return value ? options.find(option => option.key === value) : undefined;
  }, [options, value]);

  useEffect(() => {
    getIssueFields();
  }, [getIssueFields, issueTypeId]);
  return (
    <Autocomplete
      className='field'
      options={options}
      disabled={disabled}
      loading={isLoading}
      value={selected || null}
      getOptionLabel={option => option.name}
      onChange={(_, value) => onChange?.(value?.key as string)}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          variant='outlined'
          label='Select JIRA Issue Field'
          error={!!error?.message}
          helperText={error?.message}
          {...textFieldProps}
          InputProps={{ ...params.InputProps, ...textFieldProps?.InputProps }}
          InputLabelProps={{
            ...params.InputLabelProps,
            ...textFieldProps?.InputLabelProps
          }}
        />
      )}
    />
  );
};

export default JiraIssueFieldPicker;
